import * as classnames from 'classnames'
import get from 'lodash-es/get'
import head from 'lodash-es/head'
import * as React from 'react'

import { IItem } from '../../../typings/searchResults'

import * as styles from './imagePreview.module.css'

const landscapePreviewUrl = (item: IItem) => {
  const urls =
    get(item, 'previews.landscape_preview.image_urls') ||
    get(item, 'previews.icon_with_video_preview.image_urls') ||
    get(item, 'previews.icon_with_landscape_preview.image_urls') ||
    []

  return get(head(urls), 'url')
}

const squarePreviewUrl = (item: IItem) => {
  const urls =
    get(item, 'previews.landscape_preview.image_urls') ||
    get(item, 'previews.icon_with_square_preview.image_urls') ||
    get(item, 'previews.icon_with_landscape_preview.image_urls') ||
    []

  return get(head(urls), 'url')
}

const getMarketingImg = (item: IItem): any =>
  get(item, 'previews.landscape_preview.landscape_url') ||
  get(item, 'previews.icon_with_video_preview.landscape_url') ||
  get(item, 'previews.icon_with_landscape_preview.landscape_url') ||
  get(item, 'previews.icon_with_square_preview.square_url')

const getImgixImg = (item: IItem): any =>
  squarePreviewUrl(item) || landscapePreviewUrl(item) || getMarketingImg(item)

const ImagePreview = ({ item }: { item: IItem }) => {
  const imageClass = classnames(
    styles.preview,
    'preload no_preview landscape-image-magnifier'
  )

  let fallbackUsed = false

  return (
    <img
      alt={item.name}
      className={imageClass}
      src={getImgixImg(item)}
      title={item.name}
      onError={(e: any): void => {
        if (!fallbackUsed) {
          fallbackUsed = true
          e.target.src = getMarketingImg(item)
        }
      }}
    />
  )
}

export default ImagePreview
